import React, { useState } from "react";
import $ from "jquery";
import moment from "moment/moment";

const FilterModal = ({
  closeModal,
  filterModalDescTxt,
  setFilterData,
  filterData,
  setApiCalled,
  getFilterData,
  dateError,
  setDateError,
  error,
  setError,
  // setOutgoingData,
  Cdr,
  loader,
}) => {
  // const [loader, setLoader] = useState(false);

  const duration = [
    { name: "Minutes", value: "minutes" },
    { name: "Seconds", value: "seconds" },
  ];

  const call_type_incoming = [
    // Incoming
    // { name: "NOANSWER", value: "NOANSWER" },
    { name: "ANSWERED", value: "ANSWER" },
    // { name: "CHANUNAVAIL", value: "CHANUNAVAIL" },
    { name: "MISSED", value: "CANCEL" },
    // { name: "BUSY", value: "BUSY" },
  ];

  const call_type_Outgoing = [
    // outgoing
    { name: "USER BUSY", value: "BUSY" },
    { name: "AGENT HANG UP", value: "CANCEL" },
    { name: "CONNECTED", value: "ANSWER" },
    { name: "USER NOT ATTENDED", value: "NOANSWER" },
  ];

  const handleStartDateErrors = (value) => {
    setError("");
    if (filterData?.end_date === null) {
      setDateError("End Date is Missing");
    }
    if (filterData?.end_date !== null && value !== "") {
      if (value > filterData?.end_date) {
        setDateError("Start date must be lesser than end date");
      } else {
        setDateError("");
      }
    }
  };
  const handleEndDateErrors = (value) => {
    setError("");
    if (filterData?.start_date === null) {
      setDateError("Start Date is Missing");
    }
    if (filterData?.start_date !== null && value !== "") {
      if (value < filterData?.start_date) {
        setDateError("End date must be greater than Start date");
      } else {
        setDateError("");
      }
    }
  };

  const clearFilter = () => {
    // setLoader(true);
    $("#fromDate").val("");
    $("#toDate").val("");
    setApiCalled(true);
    setFilterData({
      start_date: null,
      end_date: null,
      agent_number: "",
      customer_number: "",
      duration_type: "",
      duration: null,
      condition: null,
      call_type: "",
    });
  };

  const handleStartTimeChange = (e) => {
    setFilterData({
      ...filterData,
      start_time: moment(e.$d).format("HH:mm"),
    });
  };
  const handleEndTimeChange = (e) => {
    setFilterData({
      ...filterData,
      end_time: moment(e.$d).format("HH:mm"),
    });
  };
  return (
    <div
      className="customModal ModalStyle uk-flex-top uk-open uk-flex uk-flex uk-open"
      uk-modal="esc-close: false; bg-close: false"
    >
      <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div className="filterModalContent">
          <div className="modalHeading">
            <h4>Search filter</h4>
          </div>
          <div className="modalForm">
            <div className="formHeading">
              <span>{filterModalDescTxt}</span>
            </div>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="uk-grid uk-grid-small" uk-grid="">
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="from_date">Start date</label>
                    <input
                      id="fromDate"
                      type="date"
                      value={filterData?.start_date}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          start_date: e.target.value,
                        });
                        handleStartDateErrors(e.target.value);
                      }}
                      className="uk-input"
                    />
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="to_date">End date</label>
                    <input
                      id="toDate"
                      type="date"
                      value={filterData?.end_date}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          end_date: e.target.value,
                        });
                        handleEndDateErrors(e.target.value);
                      }}
                      className="uk-input"
                    />
                  </div>
                </div>
                {dateError !== "" && (
                  <div className="uk-width-1-1 formErrors">{dateError}</div>
                )}
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="agent">Agent Number</label>
                    <input
                      type="text"
                      placeholder="please enter agent number"
                      defaultValue={filterData.agent_number}
                      className="uk-input"
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setError("");
                        }
                        setFilterData({
                          ...filterData,
                          agent_number: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="city">Client number</label>
                    <input
                      type="text"
                      placeholder="please enter client number"
                      defaultValue={filterData.customer_number}
                      className="uk-input"
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setError("");
                        }
                        setFilterData({
                          ...filterData,
                          customer_number: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="type">Duration Type</label>
                    <select
                      name="type"
                      value={filterData.duration_type}
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setError("");
                        }
                        setFilterData({
                          ...filterData,
                          duration_type: e.target.value,
                        });
                      }}
                      className="uk-select"
                    >
                      <option value="" selected disabled>
                        please select duration type
                      </option>
                      {duration.map((val, index) => {
                        return (
                          <option key={index} value={val.value}>
                            {val.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="type">Call Type</label>
                    <select
                      name="type"
                      value={filterData.call_type}
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setError("");
                        }
                        setFilterData({
                          ...filterData,
                          call_type: e.target.value,
                        });
                      }}
                      className="uk-select"
                    >
                      <option value="" selected disabled>
                        please select duration type
                      </option>
                      {Cdr === "Incoming" &&
                        call_type_incoming.map((val, index) => {
                          return (
                            <option key={index} value={val.value}>
                              {val.name}
                            </option>
                          );
                        })}
                      {Cdr === "Outgoing" &&
                        call_type_Outgoing.map((val, index) => {
                          return (
                            <option key={index} value={val.value}>
                              {val.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>

                <div className="uk-width-1-2">
                  <div className="formInputs">
                    {filterData.duration_type !== "" && (
                      <>
                        <label htmlFor="gender">Duration period</label>
                        <input
                          type="number"
                          placeholder="please enter duration in numbers"
                          value={filterData.duration}
                          className="uk-input"
                          onChange={(e) => {
                            setFilterData({
                              ...filterData,
                              duration: e.target.value,
                            });
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="uk-width-1-1">
                  <div className="formInputs">
                    {filterData.duration_type !== "" && (
                      <>
                        <label htmlFor="gender">Condition</label>
                        <br />
                        <label for="age1" className="uk-margin-right">
                          &lt;
                        </label>
                        <input
                          type="radio"
                          name="condition"
                          value="lessthan"
                          className="uk-margin-right"
                          onChange={(e) => {
                            setFilterData({
                              ...filterData,
                              condition: e.target.value,
                            });
                          }}
                        />
                        <label for="age2" className="uk-margin-right">
                          {" "}
                          &#61;{" "}
                        </label>
                        <input
                          type="radio"
                          name="condition"
                          value="equalto"
                          className="uk-margin-right"
                          onChange={(e) => {
                            setFilterData({
                              ...filterData,
                              condition: e.target.value,
                            });
                          }}
                        />
                        <label for="age3" className="uk-margin-right ">
                          &gt;
                        </label>
                        <input
                          type="radio"
                          name="condition"
                          value="greaterthan"
                          className="uk-margin-right"
                          onChange={(e) => {
                            setFilterData({
                              ...filterData,
                              condition: e.target.value,
                            });
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>

                {error !== "" && (
                  <div className="uk-width-1-1 formErrors">{error}</div>
                )}
                <div className="uk-width-1-2">
                  <div className="clearFilterBtn">
                    {/* <button
                      className="exportData-button"
                      style={{ margin: "0px" }}
                      type="button"
                      onClick={() => clearFilter()}
                    >
                      Clear filter
                    </button> */}
                    <button
                      className="exportData-button"
                      style={{ margin: "0px" }}
                      type="button"
                      onClick={() => clearFilter()}
                    >
                      {/* {loader ? (
                        <div uk-spinner="" className="loader">
                          Clearing
                        </div>
                      ) : (
                        " Clear filter"
                      )} */}
                      Clear filter
                    </button>
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="btnwrp" style={{ float: "right" }}>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={() => {
                        // setOutgoingData([]);
                        getFilterData();
                      }}
                    >
                      {loader ? (
                        <div
                          uk-spinner=""
                          className="loader loaderfilter"
                        ></div>
                      ) : (
                        "Search"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
